import { Button, EButtonColor, HeroSection, LoadingSpinner, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';
import React from 'react';
import { connect } from 'react-redux';
import { ExerciseActions } from '..';
import { getDayFromToday } from '../../base/dateUtils';
import ENV from '../../base/env';
import { EDomain } from '../../base/types';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';

export interface IPostFirstSessionPageProps {
  domain: EDomain;
  completeSessionAction: () => void;
}

export const PostFirstSessionPageFC: React.FC<IPostFirstSessionPageProps> = ({ domain, completeSessionAction }) => {
  const { t, language } = useTranslation();

  if (!language || !domain) {
    return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  }

  const lottieName = `First_Session_Complete`;
  const dayInTwoDays = getDayFromToday(2, language);
  const dayInThreeDays = getDayFromToday(3, language);

  return (
    <HeroSection lottie={lottieName} lottieLoop={false}>
      <SectionTitle>{t('Exercise.PostFirstSessionView.Title')}</SectionTitle>
      <SectionSubtitle wrapperTag="div">
        {renderStringToReact(
          t(`Exercise.PostFirstSessionView.TextHtml.${domain}`, { dayInTwoDays, dayInThreeDays }),
          ETagType.div
        )}
      </SectionSubtitle>
      <Button
        color={EButtonColor.white}
        label={t('Exercise.SessionView.Link')}
        onClick={() => completeSessionAction()}
      />
    </HeroSection>
  );
};

const mapStateToProps = (state: IState) => {
  const domain = SessionSelectors.getSessionDomain(state);

  return {
    domain,
  };
};

const mapDispatchToProps = {
  completeSessionAction: ExerciseActions.completeSession,
};

const PostFirstSessionPage = connect(mapStateToProps, mapDispatchToProps)(PostFirstSessionPageFC);

export default PostFirstSessionPage;
